export default class ApiEndpoint {
  static signIn = '/api/auth/login';

  static signUp = '/api/auth/signup';

  static signOut = '/api/auth/logout';

  static resetPassword = '/api/auth/reset';

  static inviteUser = '/api/auth/invite';

  static reInviteUser = '/api/auth/reinvite';

  static verifyToken = '/api/auth/verify';

  static searchSuggestions = '/api/search/suggestion';

  static getNewAccessToken = '/api/auth/refresh-token';

  static uploadDocument = '/api/document/upload';

  static downloadDocument = '/api/document/download';

  static getDocument = '/api/document/get';

  static documentLog = '/api/logger/document-log';

  static mapboxSearch = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';

  static plusCodeConverter = 'https://plus.codes/api';

  static fedExShippingServiceValidate = 'https://apis-sandbox.fedex.com/ship/v1/shipments/packages/validate';

  static fedExTracking = 'https://www.fedex.com/fedextrack/?cntry_code=us';
}
